<template>
    <div class="container-fluid form-container fire-alarm-test-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Domestic Fire Alarm Service
                </h1>
            </div>
        </div>
        <form
            action=""
            class="fire-alarm-certificate"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged()"
                            >
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="job_id">Job No.</label>
                            <select
                                v-if="jobs"
                                name="job_id"
                                id="job_id"
                                v-model="form.job_id"
                                class="form-control"
                                placeholder="Select a job"
                                :disabled="jobs.length < 1"
                            >
                                <option
                                    :value="null"
                                    disabled
                                >
                                    Select a job
                                </option>
                                <option
                                    v-for="job in jobs"
                                    :key="job.id"
                                    :value="job.id"
                                >
                                    {{ job.id }}: {{ job.name }}
                                </option>
                            </select>
                            <error
                                name="job_id"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="doc_no">Document No.</label>
                            <input
                                type="text"
                                id="doc_no"
                                name="doc_no"
                                v-model="form.doc_no"
                                placeholder="Document Number"
                                class="form-control"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>System Details</h3>
                        </div>
                    </div>

                    <select-row-component
                        id="service_type"
                        v-model="form.service_type"
                        label="What service are you carrying out?"
                        :options="[
                            '12 Monthly routine service',
                            'Non-routine service',
                        ]"
                    />

                    <select-row-component
                        id="fire_alarm_grade"
                        v-model="form.fire_alarm_grade"
                        label="Fire alarm grade system type"
                        :options="[
                            'C',
                            'D1',
                            'D2',
                            'F1',
                            'F2'
                        ]"
                    />

                    <select-row-component
                        id="fire_alarm_system_category"
                        v-model="form.fire_alarm_system_category"
                        label="Fire alarm system category"
                        :options="[
                            'LD1',
                            'LD2',
                            'LD3',
                            'X'
                        ]"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>System Test</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Device No.</th>
                                        <th>Location</th>
                                        <th>Interlink Test (If Fitted)</th>
                                        <th>Installation Year</th>
                                        <th>Battery Date</th>
                                        <th>Tested</th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(device, index) in form.system_devices"
                                        :key="index"
                                    >
                                        <td>
                                            <input
                                                type="number"
                                                step="1"
                                                min="0"
                                                class="form-control"
                                                v-model="device.device_no"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                class="form-control"
                                                v-model="device.location"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                class="form-control"
                                                v-model="device.interlink_test"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                type="number"
                                                step="1"
                                                class="form-control"
                                                v-model="device.install_date"
                                            >
                                        </td>
                                        <td>
                                            <input
                                                class="form-control"
                                                step="1"
                                                v-model="device.battery_date"
                                            >
                                        </td>
                                        <td>
                                            <select
                                                v-model="device.tested"
                                                class="form-control"
                                            >
                                                <option>Yes</option>
                                                <option>No</option>
                                            </select>
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-danger"
                                                @click.prevent="deleteDevice(index)"
                                            >
                                                <i class="fa fa-times" />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="flex">
                                <button
                                    class="btn btn-sm btn-secondary"
                                    type="button"
                                    @click.prevent="addDevice()"
                                >
                                    <i class="fa fa-plus" />
                                    Add Device
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Observations and Recommendations</h3>

                            <textarea
                                rows="4"
                                class="form-control"
                                v-model="form.recommendations"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Logs & Final Checks</h3>
                        </div>
                    </div>

                    <select-row-component
                        id="log_book_updated"
                        label="Has the log book been updated"
                        v-model="form.log_book_updated"
                    />

                    <select-row-component
                        id="system_fully_operational"
                        label="System left fully operational"
                        v-model="form.system_fully_operational"
                    />

                    <select-row-component
                        id="system_fault_free"
                        label="System left fully fault free"
                        v-model="form.system_fault_free"
                    />

                    <select-row-component
                        id="recommendations_reported"
                        label="Have all recommendations, outstanding issues and non-compliances been recorded and reported to the responsible person?"
                        v-model="form.recommendations_reported"
                    />
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Notes</h3>

                            <textarea
                                rows="4"
                                class="form-control"
                                v-model="form.notes"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3>Sign Off</h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select-component
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="engineer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.engineer_sign_date"
                                name="engineer_sign_date"
                                id="engineer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <label class="top">Customer Signature:</label>
                            <br>
                            <signature
                                v-if="!form.customer_signature"
                                ref="customerSignature"
                            />
                            <img
                                v-if="form.customer_signature"
                                :src="form.customer_signature"
                                alt="Customer signature"
                            >
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_name"
                                class="top"
                            >Customer Name</label>
                            <br>
                            <input
                                type="text"
                                v-model="form.customer_sign_name"
                                id="customer_sign_name"
                                name="customer_sign_name"
                                placeholder="Customer Name"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="customer_sign_name"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                            <label
                                for="customer_sign_date"
                                class="top"
                            >Date</label>
                            <br>
                            <date-picker
                                v-model="form.customer_sign_date"
                                id="customer_sign_date"
                                name="customer_sign_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="customer_sign_date"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-sm-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isLoading || isSaving || siteDevicesLoading"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isLoading || isSaving"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                                target="_blank"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id && form.customer_id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CustomerSearchComponent from "../CustomerSearch.vue";
import FormService from "../../services/FormService";
import * as moment from "moment";
import AuthService from "../../services/AuthService";
import UsesErrors from "../../mixins/UsesErrors";
import SettingsMixin from "../../mixins/SystemSettings";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesFormRouteQuery, { formRouteQueryWatchers } from "../../mixins/UsesFormRouteQuery";
import SelectRowComponent from "./parts/SelectRowComponent.vue";
import TextRowComponent from "./parts/TextRowComponent.vue";
import JobService from "../../services/JobService";
import SitesService from "../../services/SitesService";
import {fire_alarm_systems} from "../../include/Form";
import UserSelectComponent from "../UserSelectComponent.vue";
import Datetimepicker from "../DateTimePickerComponent.vue";
import signature from "../SignatureComponent.vue";

const initialDevice = {
    device_no: '',
    location: '',
    interlink_test: '',
    install_date: '',
    battery_date: '',
    tested: false,
};

const initialForm = {
    type: 'domestic_fire_alarm_service',
    customer: null,
    system_devices: [
        {
            ...initialDevice,
            device_no: 1,
        },
    ],
    engineer_sign_date: moment(),
    customer_sign_date: moment(),
};

export default {
    components: {
        signature,
        SelectRowComponent,
        'date-picker': Datetimepicker,
        UserSelectComponent,
        "customer-search": CustomerSearchComponent,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        SettingsMixin,
        UsesFormRouteQuery,
    ],
    data: function () {
        return {
            form: {...initialForm},
            token: null,
            sites: [],
            jobs: [],
            siteDevicesLoading: false,
            siteDevicesLoadFailed: false,
        }
    },
    computed: {
        canDelete: function () {
            return AuthService.user.admin_access || AuthService.user.office_access;
        },
        idParam: function () {
            return this.$route.params.id;
        },
    },

    watch: {
        ...formRouteQueryWatchers,
        idParam: {
            handler: function () {
                if (this.idParam) {
                    this.loadForm(this.idParam);
                    return;
                }

                this.form = {...initialForm};
                FormService.nextNo().then(res => {
                    this.form.doc_no = res.data;
                });
            },
            immediate: true,
        },
    },

    mounted: function () {
    },

    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id).then(res => {
                this.form = res.data;

                if (!this.form.customer) {
                    this.form.customer = {
                        company_name: '',
                    };
                }

                if (res.data.engineer_sign_date) {
                    this.form.engineer_sign_date = moment(res.data.engineer_sign_date);
                    this.form.customer_sign_date = moment(res.data.customer_sign_date);
                } else {
                    this.form.engineer_sign_date = moment();
                    this.form.customer_sign_date = moment();
                }
                if (!res.data.system_devices) {
                    this.form.system_devices = initialForm.system_devices;
                }

            }, () => {
                this.setErrorMessage('Could not load form');
            }).then(() => {
                this.clearLoading();
            });
        },

        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
                this.getJobs();
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                }
            } else {
                this.form.site_id = '';
            }
        },

        saveForm: function () {
            if (this.siteDevicesLoading) {
                return;
            }

            this.setSaving();
            if (
                this.$refs.customerSignature &&
                !this.$refs.customerSignature.isEmpty()
            ) {
                this.form.customer_signature =
                    this.$refs.customerSignature.toPng();
            }

            let data = {...this.form};
            delete data['customer'];
            delete data['site'];
            delete data['job'];
            delete data['data'];

            if (this.siteDevicesLoadFailed && !this.hasEnteredDevices()) {
                delete data.system_devices;
            }

            if (this.form.id) {
                FormService.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                FormService.create(data).then(
                    res => {
                        this.setInfoMessage("Form saved successfully");
                        this.clearSaving();
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },

        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                FormService.delete(this.form).then(
                    () => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({name: 'office.forms.search'});
                    },
                    () => {
                        this.setErrorMessage("Could not delete this form");
                    }
                )
            }
        },

        onJobLoadedFromRoute() {
            this.siteChanged();
            this.getJobs();
        },

        getJobs: function () {
            if (!this.form.customer_id) {
                this.jobs = [];
                this.form.job_id = null;
                return;
            }
            JobService.search({
                "filter[customer_id]": this.form.customer_id,
            }).then(
                (res) => {
                    this.jobs = res.data.data || [];
                },
                () => {
                    this.setErrorMessage("Could not load customer jobs");
                    this.jobs = [];
                }
            );
        },

        siteChanged: function () {
            const siteId = this.form.site_id;
            if (!siteId) {
                this.siteDevicesLoading = false;
                this.siteDevicesLoadFailed = false;
                return;
            }

            this.siteDeviceLoad = (this.siteDeviceLoad || 0) + 1;
            const loadId = this.siteDeviceLoad;
            this.siteDevicesLoading = true;
            this.siteDevicesLoadFailed = false;

            SitesService.get(siteId).then((res) => {
                if (loadId !== this.siteDeviceLoad || String(this.form.site_id) !== String(siteId)) {
                    return;
                }

                this.siteDevicesLoading = false;
                this.siteDevicesLoadFailed = false;

                const siteDevices = res.data.domestic_fire_alarm_devices || [];
                if (siteDevices.length === 0) {
                    return;
                }

                if (this.hasEnteredDevices()) {
                    const confirmed = window.confirm(
                        "Would you like to load the site devices? Devices currently added to this form will be lost."
                    );
                    if (!confirmed) {
                        return;
                    }
                }

                this.form.system_devices = siteDevices.map((device) => {
                    return {
                        device_no: device.device_no,
                        location: device.location || "",
                        interlink_test: device.interlink_test || "",
                        install_date: device.install_date || "",
                        battery_date: device.battery_date || "",
                        tested: false,
                    };
                });
            }, () => {
                if (loadId !== this.siteDeviceLoad) {
                    return;
                }
                this.siteDevicesLoading = false;
                this.siteDevicesLoadFailed = true;
                this.setErrorMessage("Could not load site devices");
            });
        },

        hasEnteredDevices: function () {
            const devices = this.form.system_devices || [];
            if (devices.length === 0) {
                return false;
            }
            if (devices.length !== 1) {
                return true;
            }

            const device = devices[0];
            if (String(device.device_no) !== "1") {
                return true;
            }

            return !!(
                device.location ||
                device.interlink_test ||
                device.install_date ||
                device.battery_date ||
                (device.tested && device.tested !== false)
            );
        },

        addDevice: function () {
            const lastDevice = this.form.system_devices[this.form.system_devices.length - 1];

            this.form.system_devices.push({
                ...initialDevice,
                device_no: lastDevice ? parseInt(lastDevice.device_no) + 1 : 1,
            });
            this.$forceUpdate();
        },

        deleteDevice: function (index) {
            this.form.system_devices.splice(index, 1)
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/DomesticFireAlarmServiceComponent.vue